
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91_46_46_46slug_93KIQRSceZ2XMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93SCAKLhrpUXMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/blogg/[...slug].vue?macro=true";
import { default as indexRgOa4swAxvMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/blogg/index.vue?macro=true";
import { default as indexSfXaLVNDN1Meta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/checkout/index.vue?macro=true";
import { default as payment6wkmjgVJTfMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/checkout/payment.vue?macro=true";
import { default as index_46clientraHw1b7MUFMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/checkout/thank-you/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexsMjXLbch5VMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/collections/index.vue?macro=true";
import { default as _91slug_93x8S6Sg8oFIMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/faq/[slug].vue?macro=true";
import { default as indexqUX6LsqMgUMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/hillceramic-rabattkoder/index.vue?macro=true";
import { default as indexkzivJECFh0Meta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/index.vue?macro=true";
import { default as indexSjzg9WuSRoMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/login/index.vue?macro=true";
import { default as _91id_93hrbLijeQigMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/qr-pr/[id].vue?macro=true";
import { default as formQvT8KH41EVMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/review/form.vue?macro=true";
import { default as indexNUp0MsUBxlMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/review/index.vue?macro=true";
import { default as _91_46_46_46slug_9329IopmvkXVMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/shop/[...slug].vue?macro=true";
import { default as indexcM7aIZxiWQMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/track/index.vue?macro=true";
export default [
  {
    name: "slug___da",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93KIQRSceZ2XMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/[...slug].vue")
  },
  {
    name: "blogg-slug___da",
    path: "/blogg/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/blogg/[...slug].vue")
  },
  {
    name: "blogg___da",
    path: "/blogg",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/blogg/index.vue")
  },
  {
    name: "checkout___da",
    path: "/checkout",
    meta: indexSfXaLVNDN1Meta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/checkout/index.vue")
  },
  {
    name: "checkout-payment___da",
    path: "/checkout/payment",
    meta: payment6wkmjgVJTfMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/checkout/payment.vue")
  },
  {
    name: "checkout-thank-you___da",
    path: "/checkout/thank-you",
    meta: index_46clientraHw1b7MUFMeta || {},
    component: () => createClientPage(() => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/checkout/thank-you/index.client.vue"))
  },
  {
    name: "collections___da",
    path: "/samlinger",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/collections/index.vue")
  },
  {
    name: "faq-slug___da",
    path: "/faq/:slug()",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/faq/[slug].vue")
  },
  {
    name: "hillceramic-rabattkoder___da",
    path: "/hillceramic-rabattkoder",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/hillceramic-rabattkoder/index.vue")
  },
  {
    name: "index___da",
    path: "/",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/index.vue")
  },
  {
    name: "login___da",
    path: "/login",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/login/index.vue")
  },
  {
    name: "qr-pr-id___da",
    path: "/qr-pr/:id()",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/qr-pr/[id].vue")
  },
  {
    name: "review-form___da",
    path: "/review/form",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/review/form.vue")
  },
  {
    name: "review___da",
    path: "/review",
    meta: indexNUp0MsUBxlMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/review/index.vue")
  },
  {
    name: "shop-slug___da",
    path: "/shop/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/shop/[...slug].vue")
  },
  {
    name: "track___da",
    path: "/track",
    meta: indexcM7aIZxiWQMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20261105104439Z/pages/track/index.vue")
  }
]